import {Alert, Box, styled} from '@mui/material';

const Grid = styled(Box)`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	row-gap: 40px;
	column-gap: 24px;
	margin-bottom: 40px;

	${({theme}) => theme.breakpoints.down('sm')} {
		row-gap: 8px;
		grid-template-columns: 1fr;
	}
`;

const PaymentSuccessAlert = styled(Alert)`
	max-width: 320px;
	text-align: left;

	& .MuiAlert-icon {
		margin-right: 12px;
	}
`;

export {Grid, PaymentSuccessAlert};
